import { render, staticRenderFns } from "./batch-distribution.vue?vue&type=template&id=57801cae&scoped=true&"
import script from "./batch-distribution.vue?vue&type=script&lang=js&"
export * from "./batch-distribution.vue?vue&type=script&lang=js&"
import style0 from "./batch-distribution.vue?vue&type=style&index=0&id=57801cae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57801cae",
  null
  
)

export default component.exports